import type { Tier } from '@/state/GameState';

export type PortrettKey =
  | 'npc_forfatter-krim'
  | 'npc_forfatter-autofiksjon'
  | 'npc_forfatter-veteran'
  | 'npc_forfatter-barnebok'
  | 'npc_forfatter-feelgood'
  | 'npc_forfatter-lyriker'
  | 'npc_forfatter-debutant';

const PORTRETT_PATHS: Record<PortrettKey, string> = {
  'npc_forfatter-krim': 'assets/characters/npc_forfatter-krim_01.webp',
  'npc_forfatter-autofiksjon': 'assets/characters/npc_forfatter-autofiksjon_01.webp',
  'npc_forfatter-veteran': 'assets/characters/npc_forfatter-veteran_01.webp',
  'npc_forfatter-barnebok': 'assets/characters/npc_forfatter-barnebok_01.webp',
  'npc_forfatter-feelgood': 'assets/characters/npc_forfatter-feelgood_01.webp',
  'npc_forfatter-lyriker': 'assets/characters/npc_forfatter-lyriker_01.webp',
  'npc_forfatter-debutant': 'assets/characters/npc_forfatter-debutant_01.webp',
};

export function alleForfatterPortretter(): Array<{ key: PortrettKey; path: string }> {
  return (Object.keys(PORTRETT_PATHS) as PortrettKey[]).map((key) => ({
    key,
    path: PORTRETT_PATHS[key],
  }));
}

export function portrettFor(sjanger: string, tier: Tier): PortrettKey {
  const s = sjanger.toUpperCase();
  if (s === 'KRIM') return 'npc_forfatter-krim';
  if (s === 'LITERARY') {
    if (tier === 'A' || tier === 'S') return 'npc_forfatter-veteran';
    return 'npc_forfatter-autofiksjon';
  }
  if (s === 'BARNEBOK') return 'npc_forfatter-barnebok';
  if (s === 'FEELGOOD' || s === 'ROMANCE') return 'npc_forfatter-feelgood';
  if (s === 'POETRY' || s === 'LYRIKK') return 'npc_forfatter-lyriker';
  if (s === 'NONFICTION') return 'npc_forfatter-veteran';
  if (s === 'FANTASY') return 'npc_forfatter-debutant';
  return 'npc_forfatter-debutant';
}

export function initialerAv(navn: string): string {
  const deler = navn
    .trim()
    .split(/\s+/)
    .filter((d) => d.length > 0);
  if (deler.length === 0) return '?';
  if (deler.length === 1) return deler[0].slice(0, 2).toUpperCase();
  return (deler[0][0] + deler[deler.length - 1][0]).toUpperCase();
}
